import { render, staticRenderFns } from "./DocFaq.vue?vue&type=template&id=601f3fd8&"
import script from "./DocFaq.vue?vue&type=script&lang=js&"
export * from "./DocFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports